<ng-container *ngIf="user">
  <app-toolbar [user]="user" [back]="false" [title]="title" [destination]=""></app-toolbar>
</ng-container>

<ng-container *ngIf="user.role else noRole">
  <div style="text-align: center; padding-top: 10px">
    <ng-container *ngIf="user.role.includes('DOTTORE')">
      <div style="text-align: center">
        <h3>Gestione pazienti</h3>
      </div>
      <div style="padding: 5px"></div>
      <app-box title="Personali" route="/patients-control-panel" image="patients.png"></app-box>
      <app-box title="Globali" route="/patients-global-control-panel" image="hospital.png"></app-box>
      <app-box title="Avvisi" route="/announcement-section" image="avviso.png"></app-box>
      <app-box title="Status applicazione" route="/general-status" image="status.png"></app-box>
      <app-box title="Esporta dati" route="/export-data" image="esporta.png"></app-box>

    </ng-container>
    <ng-container *ngIf="user.role.includes('PAZIENTE')">
      <div *ngIf="this.categoryPatient==='TELEMEDICINA'" style="text-align: center">
        <mat-card>
          <mat-card-title style="font-weight:bold;color:#009687">News - avvisi</mat-card-title>
          <mat-card-content>
            <div *ngIf="!announcement; else announcementSection">
              <h2>Nessun avviso recente.</h2>
            </div>
            <div style="padding: 5px"></div>
            <ng-template #announcementSection>
              <mat-card id="element-announcements-first">
                <mat-card-title id="title-announcement">Ultimo avviso del dott. {{announcement.doctorName}}
                  {{announcement.doctorSurname}}</mat-card-title>
                <mat-card-subtitle style="color:black">Data :
                  {{announcement.giorno}}-{{announcement.mese}}-{{announcement.anno}}</mat-card-subtitle>
                <mat-card-content>
                  {{announcement.text}}
                </mat-card-content>
              </mat-card>
            </ng-template>
          </mat-card-content>
        </mat-card>
        <div style="padding: 5px"></div>
        <mat-divider></mat-divider>
      </div>


      <div style="text-align: center">
        <h2>Questionari ricevuti</h2>
      </div>
      <mat-grid-list cols="3" rowHeight="250px">
        <mat-grid-tile>
          <app-box id="inSospeso" title="Rispondi ai questionari mandati dal medico" route="/questionnaires"
            image="questionnaires.png"></app-box>
        </mat-grid-tile>
        <mat-grid-tile>
          <app-box id="Gradimento" title="Compila il questionario di gradimento"
            route="/questionnaire-compile/gradimento/{{this.user.ssn}}" image="customer-satisfaction.png"></app-box>
        </mat-grid-tile>
        <mat-grid-tile>
          <app-box id="completati" title="Visualizza i questionari già compilati" route="/questionnaires-completed"
            image="completed.png"></app-box>
        </mat-grid-tile>
      </mat-grid-list>
      <mat-divider></mat-divider>

      <!--<div style="text-align: center">
        <h2>Dashboard</h2>
      </div>
      <mat-grid-list cols="2" rowHeight="250px">
        <mat-grid-tile>
          <app-box id="Dashboard" title="Dashboards" route="/patient-dashboard" image="patient-dashboard.png"></app-box>
          </mat-grid-tile>
        <mat-grid-tile>
        <app-box id="Announcements" title="Avvisi dai medici" route="/patient-announcements" image="avviso.png"></app-box>
        </mat-grid-tile>
        <mat-grid-tile>
          <app-box id="FAQ" title="Domande più frequenti" route="/patient-faq" image="question-mark-round-line.png"></app-box>
          </mat-grid-tile>
      </mat-grid-list>
      <mat-divider></mat-divider>-->

      <!-- 
        //OLD VERSIONE CONTATTA IL CENTRO
        <div style="text-align: center">
        <h2>Contatta il centro</h2>
      </div>
      <div style="padding: 5px"></div>
      <app-box title="Interagisci con il medico" route="/contact-center" image="hospital.png"></app-box>
      //FINE OLD VERSIONE -->

      <!--Caso telemedicina: anche avvisi-->
      <ng-container *ngIf="this.categoryPatient==='TELEMEDICINA'; else standardPatient">
        <div style="text-align: center">
          <h2>Informazioni</h2>
        </div>
        <mat-grid-list cols="3" rowHeight="250px">
          <mat-grid-tile>
            <app-box title="Interagisci con il medico" route="/contact-center" image="hospital.png"></app-box>
          </mat-grid-tile>
          <mat-grid-tile>
            <app-box id="Announcements" title="Avvisi dai medici" route="/patient-announcements" image="avviso.png">
            </app-box>
          </mat-grid-tile>
          <mat-grid-tile>
            <app-box id="FAQ" title="Domande più frequenti" route="/patient-faq" image="question-mark-round-line.png">
            </app-box>
          </mat-grid-tile>
        </mat-grid-list>
      </ng-container>

      <!--Cado standard: non avvisi-->
      <ng-template #standardPatient>
        <div style="text-align: center">
          <h2>Informazioni</h2>
        </div>
        <mat-grid-list cols="2" rowHeight="250px">
          <mat-grid-tile>
            <app-box title="Interagisci con il medico" route="/contact-center" image="hospital.png"></app-box>
          </mat-grid-tile>
          <mat-grid-tile>
            <app-box id="FAQ" title="Domande più frequenti" route="/patient-faq" image="question-mark-round-line.png">
            </app-box>
          </mat-grid-tile>
        </mat-grid-list>
      </ng-template>


      <div style="padding: 10px"></div>
    </ng-container>
  </div>
</ng-container>

<ng-template #noRole>
  C'è qualcosa che non va...
</ng-template>